import { InlineNotification } from '@carbon/react';
import type { SharedWith } from './types';
import { sharedAnchorMessage } from './utils';
import style from './party-detail.module.scss';

interface SharedAnchorNoticeProps {
  sharedWith: SharedWith | null | undefined;
  subject?: string;
}

/**
 * Warns that an edit also updates the other parties sharing this entity;
 * renders nothing when no other party shares it.
 *
 * @param {SharedAnchorNoticeProps} props - Who shares the entity, and the subject the message names.
 * @return {JSX.Element | null} The warning, or null when the entity is not shared.
 */
export function SharedAnchorNotice({
  sharedWith,
  subject,
}: SharedAnchorNoticeProps) {
  const message = sharedAnchorMessage(sharedWith, subject);
  if (!message) return null;
  return (
    <InlineNotification
      kind="warning"
      lowContrast
      hideCloseButton
      title=""
      subtitle={message}
      className={style.sharedAnchorNotice}
    />
  );
}
